<template>
  <pdl-button
    button
    text
    icon-right
    xsmall
    underline
    class="mt-25"
    icon="info"
    qaid="sub-family-learn-more-dialog-button"
    @click="openDialog"
  >
    <span class="text-xs">{{ $t('text.learn.more') }}</span>
    <sub-family-learn-more-dialog
      :is-dialog-visible="isDialogVisible"
      :sub-families-with-descriptions="subFamiliesWithDescriptions"
      :learn-more-dialog-title="learnMoreDialogTitle"
      @close="closeDialog"
    />
  </pdl-button>
</template>

<script>
import {PdlButton} from '@pedal/pdl-button';
import SubFamilyLearnMoreDialog from '@/familyDetailsPage/components/SubFamilyLearnMoreDialog.vue';

export default {
  components: {PdlButton, SubFamilyLearnMoreDialog},
  props: {
    subFamiliesWithDescriptions: {
      type: Array,
      required: true,
    },
    learnMoreDialogTitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isDialogVisible: false,
    };
  },
  methods: {
    openDialog() {
      this.isDialogVisible = true;
    },
    closeDialog() {
      this.isDialogVisible = false;
    },
  },
};
</script>
